// @ts-check
import './view-nav-floating-modal.css';
import { h } from 'preact';

import ViewNavFloatButton from './components/ViewNavFloatButton/';

/**
 * @param {object} props
 * @param {import('../../types/').View[]} props.views
 * @param {import('../../types/').View} props.activeView
 * @param {(id: string) => void} props.onClick
 * @returns
 */
export default function ViewNavFloatingModal({ views, activeView, onClick }) {
	return (
		<div className="view-nav-floating-modal-wrapper">
			<nav className="view-nav-floating-modal-container">
				<ul className="view-nav-floating-modal-items-container">
					{views.map(view => (
						<li className="view-nav-floating-item-container">
							<ViewNavFloatButton {...view} isSelected={activeView && activeView.id === view.id} onClick={onClick} />
						</li>
					))}
				</ul>
			</nav>
		</div>
	);
}
